import { SVGProps } from 'react';

const Tornado = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 4H3m15 4H6m13 4H9m7 4h-6m1 4H9"
    />
  </svg>
);
export default Tornado;
